export const environment = {
  production: true,
  host: 'https://api.skiss.org',
  port: '443',
  apiBaseUrl: 'https://api.skiss.org',
  wsHost: 'wss://api.skiss.org',
  wsPort: '443',
  vapidPublicKey:
    'BC4S8NXZHjMbjOKz4f5LwWJnIkYyDAc530UaiWz-1CqnHj0oPzGa7DZs9Sjuv8QoNyePAiyE25P5jfTwkyk-Cog',
};
